module.exports = __webpack_public_path__ + "static/img/9.a7e8670.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/2/sp/9.png
// module id = 15pG
// module chunks = 0